import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from "../../../../../shared/base-component";
import { ModalV2Component } from "../../../../../shared/modal-v2/modal-v2.component";
import { InputSelectComponent } from "../../../../../shared/input-select/input-select.component";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Cultures } from "../../../../../core/constants/cultures";
import { ButtonComponent } from "../../../../../shared/button/button.component";
import { SharedModule } from "../../../../../shared/shared.module";
import { Translation } from "../../../../../core/models/translation.model";
import { TrialService } from "../../../../../core/services/trial.service";

@Component({
  selector: 'app-trial-notification-centre-form',
  standalone: true,
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    SharedModule
  ],
  templateUrl: './trial-notification-centre-form.component.html',
  styleUrl: './trial-notification-centre-form.component.scss'
})
export class TrialNotificationCentreFormComponent extends BaseComponent implements OnInit {
  @ViewChild('modal') modal: ModalV2Component;
  @ViewChild('cultureSelect') cultureSelect: InputSelectComponent;

  @Input() trialId: string;

  private readonly _trialService = inject(TrialService);

  loading: boolean = false;
  translations: Translation[] = [];
  cultureForms: FormGroup[] = [];
  availableCultures: { value: string, text: string }[] = [];
  filteredCultures: { value: string, text: string }[] = [];
  form: FormGroup = new FormGroup({
    isBusy: new FormControl<boolean>(false),
    selectedCulture: new FormControl<string>('en')
  });

  constructor() {
    super();

    Cultures.all().forEach(culture => {
      this.availableCultures.push({ value: culture.culture, text: culture.name });
    });
    this.filteredCultures = this.availableCultures;
  }

  ngOnInit() {
  }

  buildCultureForms() {
    this.cultureForms = [];
    this.availableCultures.forEach((culture) => {
      let translation = this.translations.find(t => t.culture === culture.value);
      let form = new FormGroup({
        culture: new FormControl<string>(culture.value),
        text: new FormControl<string>(translation?.value ?? '')
      });

      form.valueChanges.subscribe(changes => {
        this.setValuesOnTranslationsArray(changes);
      });

      this.cultureForms.push(form);
    });
  }

  setValuesOnTranslationsArray(changes: any) {
    if (!this.translations)
      this.translations = [];

    let translation = this.translations.find(t => t.culture === changes.culture);
    if (translation) {
      translation.value = changes.text;
    } else {
      this.translations.push(new Translation({culture: changes.culture, value: changes.value}))
    }
  }

  show() {
    this.modal.show();

    this.loading = true;
    this._trialService.getNotificationCentreText(this.trialId).subscribe({
      next: translations => {
        this.translations = translations;

        this.form.patchValue({
          selectedCulture: 'en',
        })

        this.buildCultureForms();
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this._alertService.showErrorAlert(err);
      }
    });
  }

  onCultureFiltered(value: string) {
    // Trim the input value and convert it to lowercase for case-insensitive filtering
    const filterValue = value.trim().toLowerCase();

    this.filteredCultures = this.availableCultures.filter(x =>
      x.text.toLowerCase().includes(filterValue)
    );
  }

  onSubmit() {
    this.form.patchValue({isBusy: true});

    this._trialService.updateNotificationCentreText(this.trialId, this.translations).subscribe({
      next: () => {
        this.form.patchValue({isBusy: false});
        this._alertService.showSuccessAlert("Notification centre has been successfully updated.");
        this.modal.hide();
      },
      error: err => {
        this._alertService.showErrorAlert(err);
        this.form.patchValue({isBusy: false});
      }
    });
  }

}
